var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56017 4.71922V7.35922C8.56017 7.84523 8.95416 8.23922 9.44017 8.23922H12.0802M13.8402 1.19922H7.67996C6.70795 1.19922 5.91997 1.98719 5.91996 2.95921V4.71922M13.8402 1.19922H14.3311C14.5789 1.19922 14.8148 1.3036 14.9855 1.48322C15.2421 1.75316 15.6485 2.16879 16.0402 2.51922C16.3471 2.79387 16.8294 3.28676 17.1182 3.58632C17.2743 3.74831 17.3602 3.96461 17.3602 4.18963L17.3601 4.71922M13.8402 1.19922V3.83922C13.8402 4.32523 14.2342 4.71922 14.7202 4.71922H17.3601M17.3601 4.71922L17.3599 13.5193C17.3599 14.4913 16.5719 15.2792 15.5999 15.2792H12.0799M10.7602 6.03922C10.3685 5.68879 9.9621 5.27316 9.70552 5.00322C9.5348 4.8236 9.2989 4.71922 9.05108 4.71922H2.39996C1.42794 4.71922 0.639967 5.50719 0.639961 6.47921L0.639893 17.0392C0.639886 18.0112 1.42786 18.7992 2.39989 18.7992L10.3199 18.7992C11.2919 18.7992 12.0799 18.0113 12.0799 17.0393L12.0802 7.70963C12.0802 7.48462 11.9943 7.26831 11.8382 7.10632C11.5494 6.80676 11.0671 6.31387 10.7602 6.03922Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.552dbc860c33231f510eeb94d0c421ac.svg";
export { ForwardRef as ReactComponent };